export enum ClaimStatus {
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  PARTIALLY_DENIED = "PARTIALLY_DENIED",
  PENDING = "PENDING",
}

export enum DenialStatus {
  NEW = "NEW",
  WAITING_ON_PAYER = "WAITING_ON_PAYER",
  RESOLVED = "RESOLVED",
}

export enum ReviewStatus {
  ACCEPTED = "ACCEPTED",
  MODIFIED = "MODIFIED",
  REVIEW = "REVIEW",
  BYPASS = "BYPASS",
  ARCHIVED = "ARCHIVED",
  TEST = "TEST",
  VALIDATING = "VALIDATING",
}

export enum PaymentType {
  CHECK = "CHECK",
  EFT = "EFT",
  VIRTUAL_CARD = "VIRTUAL_CARD",
  PRE_D = "PRE_D",
}

export enum CreatedByActor {
  SYSTEM = "SYSTEM",
  HUMAN = "HUMAN",
}

export enum PREDEFINED_CLAIM_FILTERS {
  REVIEW = "Review",
  DENIALS = "Denials",
  ALL_CLAIMS = "All Claims",
}

export enum REVIEW_VIEW {
  DENISE = "denise",
  POSTIE = "postie",
}

export enum PREDEFINED_BANK_TRANSACTION_FILTERS {
  REVIEW = "Review",
  PENDING = "Pending",
  ALL = "All",
}

export enum PREDEFINED_INSURANCE_VERIFICATION_FILTERS {
  QUEUED = "Queued",
  REVIEW = "Review",
  ALL = "All",
}

export enum WieldyStatus {
  UNKNOWN = "UNKNOWN",
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}

export enum AdjustmentType {
  PROCESSING_FEE = "PROCESSING_FEE",
  INTEREST = "INTEREST",
  FORWARDING_BALANCE = "FORWARDING_BALANCE",
  OVERPAYMENT_RECOVERY = "OVERPAYMENT_RECOVERY",
  INTERIM_SETTLEMENT = "INTERIM_SETTLEMENT",
}
